"use strict";

define('rs/models/notification',['rs/models/abstract', 'moment'], function (AbstractModel, moment) {
  var Notification = AbstractModel.extend({
    serverProperties: ['activityDate', 'code', 'createDate', 'id', 'text', 'type', 'updateUserAuthId', 'version', 'viewed', 'viewDate'],
    initialize: function initialize() {
      this.listenTo(this, 'change:viewDate', function () {
        this.setViewed(this.getViewDate() != null);
      });
      this._super.apply(this, arguments);
    },
    setViewDate: function setViewDate(date) {
      this.setViewed(date != null);
      return this._super.apply(this, arguments);
    },
    getNotificationTitle: function getNotificationTitle() {
      return this.getText();
    },
    getDateString: function getDateString() {
      return moment(this.getCreateDate()).calendar();
    },
    isUrgent: function isUrgent() {
      return false;
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      'notification': function notification(data) {
        return this.models(data);
      }
    },
    requestAll: function requestAll() {
      return this.get('notification');
    },
    requestSetViewed: function requestSetViewed(notifications) {
      var ids = _.pluck(notifications, 'id'),
        notification = null,
        len = notifications ? notifications.length : 0,
        i = 0;
      return this.post('notification/viewed', ids, {
        jsonBody: true
      }).then(function () {
        for (i = 0; i < len; ++i) {
          notification = notifications[i];
          notification.setViewDate(new Date().getTime());
        }
      });
    },
    requestDelete: function requestDelete(id) {
      return this.del('notification/' + id);
    },
    requestDeleteAll: function requestDeleteAll() {
      return this.del('notification/all');
    }
  });
  return Notification;
});

